import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "react-router-dom";

type Post = {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  published_at: string | null;
};

export default function BlogIndex() {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("posts")
      .select("id,title,slug,excerpt,published_at")
      .eq("status", "published")
      .order("published_at", { ascending: false, nullsFirst: false })
      .limit(20)
      .then(({ data }) => setPosts(data ?? []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-6">Loading…</div>;

  return (
    <main className="mx-auto max-w-3xl px-6 py-10">
      <h1 className="text-2xl font-semibold">Blog</h1>
      <div className="mt-6 grid gap-4">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`}>
            <Card>
              <CardHeader>
                <CardTitle>{p.title}</CardTitle>
                {p.excerpt ? (
                  <CardDescription>{p.excerpt}</CardDescription>
                ) : null}
              </CardHeader>
            </Card>
          </Link>
        ))}
        {posts.length === 0 && (
          <p className="text-muted-foreground">No posts yet.</p>
        )}
      </div>
    </main>
  );
}
